module.exports = __webpack_public_path__ + "img/blank.f2f8932d.png";